<!--
    主页
        oem 工厂OEM
 -->

<template>
  <div class="content">
    <div class="content">
      <el-row :gutter="10">
        <el-col
          :span="6"
          v-for="(item, index) in list"
          :key="index"
          style="padding: 5px"
        >
          <el-card :body-style="{ padding: '0px' }" class="card-style">
            <el-image
              :src="item.img"
              class="image"
              style="width: 100%; height: 250px"
              fit="scale-down"
            ></el-image>
            <div style="cursor: pointer; height: 112px">
              <div
                style="text-align: left; padding-left: 5px"
                @click="hadnClick(item.id)"
              >
                <!-- <h5>{{ item.title }}</h5> -->
                <h5>
                  {{
                    item.title.length > 20
                      ? item.title.slice(0, 15) + '...'
                      : item.title
                  }}
                </h5>
                <p style="height: 45px">
                  {{
                    item.con.length > 30
                      ? item.con.slice(0, 30) + '...'
                      : item.con
                  }}
                </p>
                <p>报价：{{ item.price }}</p>
              </div>
              <div class="footer-right">
                <p>所在地：{{ item.address }}</p>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="sum_page"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {
      list: [],
      currentPage: 1,
      pageSize: 10,
      sum_page: 0, //列表总条数
      value: false,
    };
  },
  mounted() {},
  created() {
    this.httpTable();
  },
  methods: {
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.httpTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.httpTable();
    },
    hadnClick(item) {
      this.$router.push({ path: '/ShareBed', query: { id: item } });
    },
    httpTable(e) {
      if (e == 1) {
        this.currentPage = 1;
      }
      const payload = {
        act: '0',
        punm: this.pageSize,
        p: this.currentPage,
        cate_id: '4',
        sub_id: '10',
      };
      this.$axios
        .post('wb/index.php/Newicp/product_list', payload, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*',
          },
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status === 1) {
            this.list = res.data.info;
            this.sum_page = Number(res.data.total_num);
            console.log(this.sum_page, '  this.sum_page');
          } else {
            console.log(111);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.content {
  height: 100%;
  /* background: lawngreen; */
  padding: 10px;
}

.time {
  font-size: 13px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.footer-right p {
  padding-right: 5px;
  font-weight: 550;
  text-align: right;
}

.image {
  width: 100%;
  display: block;
  height: 250px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}
.el-col-6 {
  width: 20%;
}
</style>
